import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// ⬇️ add this import
import { ThemeProvider } from "./theme/ThemeProvider";
import { UserProfileProvider } from "./context/UserProfileContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <UserProfileProvider>
        <App />
      </UserProfileProvider>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
